import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";

export class ContactsService {
    base(path) { return `${BASE_URL}/api-v1/people/${path}` }

    async list(params = {}) {
        const url = this.base(`contact/list`);
        return await axios.get(url, { params }).then(r => r.data);
    }

    async create(data) {
        const form = new FormData();
        Object.keys(data).forEach(k => form.append(k, data[k]));
        const url = this.base(`contact/create`);
        return await axios.post(url, form, { withCredentials: true }).then(r => r.data);
    }

    async view(id) {
        return await axios.get(this.base(`contact/${id}/view`)).then(r => r.data);
    }

    async save(id, data) {
        const form = new FormData();
        Object.keys(data).forEach(k => { if (k !== 'id') form.append(k, data[k]); });
        return await axios.post(this.base(`contact/${id}/save`), form, { withCredentials: true }).then(r => r.data);
    }

    async remove(id) {
        return await axios.post(this.base(`contact/${id}/delete`)).then(r => r.data);
    }

    async addComment(contactId, text) {
        const form = new FormData();
        form.append('text', text);
        return await axios.post(this.base(`comment/${contactId}/contact`), form, { withCredentials: true }).then(r => r.data);
    }

    async upload(contactId, file, fileType = '', note = '') {
        const form = new FormData();
        form.append('file', file);
        if (fileType) form.append('file_type', fileType);
        if (note) form.append('note', note);
        return await axios.post(this.base(`file/${contactId}/upload`), form, { withCredentials: true }).then(r => r.data);
    }

    async createOpportunity(data) {
        const form = new FormData();
        Object.keys(data).forEach(k => form.append(k, data[k]));
        return await axios.post(this.base(`opportunity/create`), form, { withCredentials: true }).then(r => r.data);
    }

    async createTrattenuta(data) {
        const form = new FormData();
        Object.keys(data).forEach(k => form.append(k, data[k]));
        return await axios.post(this.base(`trattenuta/create`), form, { withCredentials: true }).then(r => r.data);
    }

    async deleteTrattenuta(id) {
        return await axios.post(this.base(`trattenuta/${id}/delete`)).then(r => r.data);
    }
}

export class OpportunitiesService {
    base(path) { return `${BASE_URL}/api-v1/people/${path}` }

    async list(params = {}) { return await axios.get(this.base(`opportunity/list`), { params }).then(r => r.data); }
    async create(data) {
        const form = new FormData(); Object.keys(data).forEach(k => form.append(k, data[k]));
        return await axios.post(this.base(`opportunity/create`), form, { withCredentials: true }).then(r => r.data);
    }
    async view(id) { return await axios.get(this.base(`opportunity/${id}/view`)).then(r => r.data); }
    async save(id, data) {
        const form = new FormData(); Object.keys(data).forEach(k => { if (k !== 'id') form.append(k, data[k]); });
        return await axios.post(this.base(`opportunity/${id}/save`), form, { withCredentials: true }).then(r => r.data);
    }
    async remove(id) { return await axios.post(this.base(`opportunity/${id}/delete`)).then(r => r.data); }
    async addComment(opportunityId, text) {
        const form = new FormData(); form.append('text', text);
        return await axios.post(this.base(`comment/${opportunityId}/opportunity`), form, { withCredentials: true }).then(r => r.data);
    }
    async history(id) { return await axios.get(this.base(`opportunity/${id}/history`)).then(r => r.data); }
}

export class InstituteService {
    base(path) { return `${BASE_URL}/api-v1/product/${path}` }
    async list() { return await axios.get(this.base(`institute/list`)).then(r => r.data); }
}

export class FilesService {
    base(path) { return `${BASE_URL}/api-v1/people/${path}` }
    async list(params = {}) { return await axios.get(this.base(`file/list`), { params }).then(r => r.data); }
    async view(id) { return await axios.get(this.base(`file/${id}/view`)).then(r => r.data); }
    async remove(id) { return await axios.post(this.base(`file/${id}/delete`)).then(r => r.data); }
}

export class CommentsService {
    base(path) { return `${BASE_URL}/api-v1/people/${path}` }
    async list(params = {}) { return await axios.get(this.base(`comment/list`), { params }).then(r => r.data); }
    async view(id) { return await axios.get(this.base(`comment/${id}/view`)).then(r => r.data); }
    async remove(id) { return await axios.post(this.base(`comment/${id}/delete`)).then(r => r.data); }
}


